import api from "./apiService";

export const getTopics = (data) => api().post(`/admin/getTopics`, data).then(response => response); 
export const addTopic = (data) => api().post(`/admin/addTopic`, data).then(response => response); 
export const updateTopic = (id, data) => api().put(`/admin/updateTopic/${id}`, data).then(response => response); 
export const removeTopic = (id) => api().delete(`/admin/removeTopic/${id}`).then(response => response); 
export const upateTopicStatus = (id, data) => api().put(`/admin/upateTopicStatus/${id}`, data).then(response => response); 
export const getTopicFilter = (data) => api().get(`/admin/getTopicFilter`).then(response => response); 


export const getSubTopics = (data) => api().post(`/admin/getSubTopics`, data).then(response => response); 
export const addSubTopic = (data) => api().post(`/admin/addSubTopic`, data).then(response => response); 
export const updateSubTopic = (id, data) => api().put(`/admin/updateSubTopic/${id}`, data).then(response => response); 
export const removeSubTopic = (id, data) => api().delete(`/admin/removeSubTopic/${id}`).then(response => response); 
export const getSubTopicsByTopic = () => api().get(`/admin/getSubTopicsByTopic`).then(response => response); 


const services = {
    getTopics, addTopic, updateTopic, removeTopic,
    getSubTopics, addSubTopic, updateSubTopic, removeSubTopic
}


export default services;